import React, { CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { BillSummary } from '@enview/interface/types/bills/BillSummary';
import { Cell, flexRender } from '@tanstack/react-table';
import { CSS } from '@dnd-kit/utilities';
import './Tables.scss';

export const DragAlongCell = ({ cell }: { cell: Cell<BillSummary, unknown> }) => {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
  });

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: 'relative',
    transform: CSS.Translate.toString(transform),
    transition: 'width transform 0.2s ease-in-out',
    width: cell.column.getSize(),
    minWidth: cell.column.getSize(),
    maxWidth: cell.column.getSize(),
    zIndex: isDragging ? 1 : 0,
    textAlign: cell.column.columnDef.meta?.align ?? 'left',
  };

  return (
    <td ref={setNodeRef} style={style}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};

export default DragAlongCell;
